import { render, staticRenderFns } from "./ExchangeTruck.vue?vue&type=template&id=4cb66ab5&scoped=true"
import script from "./ExchangeTruck.vue?vue&type=script&lang=js"
export * from "./ExchangeTruck.vue?vue&type=script&lang=js"
import style0 from "./ExchangeTruck.vue?vue&type=style&index=0&id=4cb66ab5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb66ab5",
  null
  
)

export default component.exports